import styled from "styled-components";


export const ProgressContainer = styled.div`
    bottom: 0;
`;

export const ProgressBarSVG = styled.svg`
    width: 100%;
    height: 6px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
`;



// WEBPACK FOOTER //
// ./src/Components/ProgressBar/ProgressBarStyle.js